import { signal } from '@angular/core';

export class PnBaseDialog {
    public isVisible = signal<boolean>(false);

    public showModal() {
        this.isVisible.set(true);
    }

    public hideModal() {
        this.isVisible.set(false);
    }

    public toggleModal() {
        this.isVisible.update((visible) => !visible);
    }
}
